import React, { useEffect, useRef } from "react";
import { Message, MessageSender } from "./types";
import RequestWrapper from "../../../../components/RequestWrapper";

interface ChatInterfaceProps {
  messages: Message[];
  isLoading: boolean;
  isError: boolean;
  interimTranscript: string;
}

const ChatInterface: React.FC<ChatInterfaceProps> = ({
  messages,
  isError,
  isLoading,
  interimTranscript,
}) => {
  const chatContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTo({
        top: chatContainerRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [messages.length, interimTranscript]);

  return (
    <div className="flex flex-col h-full rounded-xl overflow-hidden max-h-[480px]">
      <RequestWrapper data={messages} isLoading={isLoading} isError={isError}>
        <div
          ref={chatContainerRef}
          className="flex flex-col flex-1 p-3 overflow-y-auto"
        >
          {messages.map((message, index) => (
            <div
              key={index}
              className={`max-w-[70%] mb-2 p-2 rounded-2xl ${
                message.sender === MessageSender.user
                  ? "bg-[#0076E9] text-white self-end rounded-br-sm rounded-bl-2xl"
                  : "bg-gray-200 text-black self-start rounded-br-2xl rounded-bl-sm"
              }`}
            >
              {message.message}
            </div>
          ))}

          {interimTranscript && (
            <div
              className={`max-w-[70%] mb-2 p-2 rounded-2xl ${"bg-[#0076E9] text-white self-end rounded-br-sm rounded-bl-2xl"}`}
            >
              {interimTranscript}
            </div>
          )}
        </div>
      </RequestWrapper>
    </div>
  );
};

export default ChatInterface;
